import React from 'react'
import { FieldProps, getIn } from 'formik'
import { useTranslation } from 'react-i18next'

interface FormikFieldProps extends FieldProps {
  hint?: string
  disabled?: boolean
  children?: React.ReactNode
}

export const withFormikFields = (Component: any) => {
  return ({
    field,
    hint,
    disabled,
    form: { isSubmitting, touched, errors },
    children,
    ...restProps
  }: FormikFieldProps): any => {
    const fieldError = getIn(errors, field.name)
    const showError = getIn(touched, field.name) && !!fieldError
    const { t } = useTranslation()
    return (
      <Component
        hint={hint}
        error={showError ? t(fieldError) : undefined}
        disabled={disabled ?? isSubmitting}
        {...field}
        {...restProps}
      >
        {children}
      </Component>
    )
  }
}
